import React from 'react';
import { NavLink, useHistory } from 'react-router-dom';
// Chakra imports
import {
  Alert,
  AlertIcon,
  Box,
  Button,
  Checkbox,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  Icon,
  Input,
  InputGroup,
  InputRightElement,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';

import DefaultLayout from './Layout';

import { MdOutlineRemoveRedEye } from 'react-icons/md';
import { RiEyeCloseLine } from 'react-icons/ri';
import { useAuth } from '../../Context/AuthContext';

function UpdatePassword() {
  const textColor = useColorModeValue('#1B254B', 'white');
  const textColorSecondary = '#A0AEC0';

  const brandStars = useColorModeValue('#422AFB', '#7551FF');

  const [passShow, setPassShow] = React.useState(false);
  const [confirmShow, setConfirmShow] = React.useState(false);
  const [error, setError] = React.useState('');
  const passwordRef = React.useRef();
  const passwordConfirmRef = React.useRef();
  const history = useHistory();
  const {
    isSignInWithEmailLinkHandle,
    signInWithEmailLinkHandle,
    updatePasswordHandle,
  } = useAuth();

  const handleUpdatePassword = async e => {
    e.preventDefault();
    if (
      passwordRef.current.value.length < 7 ||
      passwordConfirmRef.current.value.length < 7
    ) {
      setError('Password should be at least 8 characters long');
      setTimeout(() => {
        setError('');
      }, 3000);
      return;
    }
    // check if both the passwords match
    if (passwordRef.current.value === passwordConfirmRef.current.value) {
      // save to db
      if (isSignInWithEmailLinkHandle(window.location.href)) {
        // save password to db and sign in with email to verify
        let email = localStorage.getItem('signInWithEmail');
        if (!email) {
          email = prompt('Please Enter your email');
        }
        try {
          // save to db
          e.target.disabled = true;
          const result = await signInWithEmailLinkHandle(
            email,
            window.location.href
          );
          const user = result.user;
          if (user) {
            const token = await user.getIdToken();
            localStorage.setItem('accessToken', token);
          }
          updatePasswordHandle(user, passwordRef.current.value);
          localStorage.removeItem('signInWithEmail');
          history.push('/');
        } catch (error) {
          setError('Some error occured: ' + String(error?.code).split('/')[1]);
          setTimeout(() => {
            setError('');
            e.target.disabled = false;
          }, 3000);
          console.log(error);
        }
      }
    } else {
      setError('Passwords do not match');
      setTimeout(() => {
        setError('');
      }, 3000);
    }
  };

  return (
    <DefaultLayout>
      <Box w="100%">
        {error && (
          <Alert status="error">
            <AlertIcon />
            {error}
          </Alert>
        )}
      </Box>
      <Flex
        maxW={{ base: '100%', md: 'max-content' }}
        w="100%"
        mx={{ base: 'auto', lg: '0px' }}
        me="auto"
        h="100%"
        alignItems="start"
        justifyContent="center"
        mb={{ base: '30px', md: '60px' }}
        px={{ base: '25px', md: '0px' }}
        mt={{ base: '40px', md: '14vh' }}
        flexDirection="column"
      >
        <Box me="auto">
          <Heading color={textColor} fontSize="36px" mb="10px">
            Update Password
          </Heading>
          <Text
            mb="36px"
            ms="4px"
            color={textColorSecondary}
            fontWeight="400"
            fontSize="md"
          >
            Enter new password to update
          </Text>
        </Box>
        <Flex
          zIndex="2"
          direction="column"
          w={{ base: '100%', md: '420px' }}
          maxW="100%"
          background="transparent"
          borderRadius="15px"
          mx={{ base: 'auto', lg: 'unset' }}
          me="auto"
          mb={{ base: '20px', md: 'auto' }}
        >
          <FormControl>
            <FormLabel
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              display="flex"
            >
              Password<Text color={brandStars}>*</Text>
            </FormLabel>
            <InputGroup size="md">
              <Input
                isRequired={true}
                fontSize="sm"
                placeholder="Min. 8 characters"
                mb="24px"
                size="lg"
                type={passShow ? 'text' : 'password'}
                variant="auth"
                outline="1px solid #e0e5f2"
                ref={passwordRef}
              />
              <InputRightElement display="flex" alignItems="center" mt="4px">
                <Icon
                  color={textColorSecondary}
                  _hover={{ cursor: 'pointer' }}
                  as={passShow ? RiEyeCloseLine : MdOutlineRemoveRedEye}
                  onClick={() => setPassShow(!passShow)}
                />
              </InputRightElement>
            </InputGroup>
            <FormLabel
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              display="flex"
            >
              Confirm Password<Text color={brandStars}>*</Text>
            </FormLabel>
            <InputGroup size="md">
              <Input
                isRequired={true}
                fontSize="sm"
                placeholder="Min. 8 characters"
                mb="24px"
                size="lg"
                type={confirmShow ? 'text' : 'password'}
                variant="auth"
                outline="1px solid #e0e5f2"
                ref={passwordConfirmRef}
              />
              <InputRightElement display="flex" alignItems="center" mt="4px">
                <Icon
                  color={textColorSecondary}
                  _hover={{ cursor: 'pointer' }}
                  as={confirmShow ? RiEyeCloseLine : MdOutlineRemoveRedEye}
                  onClick={() => setConfirmShow(!confirmShow)}
                />
              </InputRightElement>
            </InputGroup>

            <Button
              fontSize="sm"
              variant="brand"
              fontWeight="500"
              w="100%"
              h="50"
              mb="24px"
              background="#422AFB"
              color="white"
              onClick={handleUpdatePassword}
            >
              Update Password
            </Button>
          </FormControl>
        </Flex>
      </Flex>
    </DefaultLayout>
  );
}

export default UpdatePassword;
